import { render, staticRenderFns } from "./screw-warning.vue?vue&type=template&id=f0810c2c&"
import script from "./screw-warning.vue?vue&type=script&lang=js&"
export * from "./screw-warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports